import React from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import { Nav, Navbar, NavDropdown } from 'react-bootstrap'
import logo from '../../logo.svg';
import ShowBankEntries from '../banks/ShowBankEntries';
import CreateBankEntry from '../banks/CreateBankEntry';
import EditBankEntry from '../banks/EditBankEntry';
import About from "../pages/About";
import Home from "../pages/Home";
import ShowAgents from "../commercial_network/ShowAgents";
import EditAgent from "../commercial_network/EditAgent";
import RootPage from "../pages/RootPage";
import ShowAgent from "../commercial_network/ShowAgent";
import Settings from "../pages/Settings";
import InvoicesPage from '../pages/InvoicesPage';
import Sales from '../sales/Sales';
import { AiOutlineLogout } from "react-icons/ai";
import Button from 'react-bootstrap/Button';
import TeleconnectSales from '../teleconnect/TeleconnectSales';
import TeleconnectCredits from '../teleconnect/TeleconnectCredits';
import TeleconnectAgents from '../teleconnect/TeleconnectAgents';

const RenderBrowserRouter = (props) => {

  const t = props.t;
  const i18n = props.i18n;

  return (
    <BrowserRouter>
      <div className="App">

        <Navbar bg="dark" variant="dark" sticky="top" expand="sm" collapseOnSelect>

          <Navbar.Brand as={Link} to="/">
            <img alt="logo" src={logo} width="40px" height="40px" />{' '}
            {t('pages.home')}
          </Navbar.Brand>

          <Navbar.Toggle className="coloring" />
          <Navbar.Collapse>

            <Nav className="me-auto" style={{ marginLeft: "20px" }}>

              <Nav.Link as={Link} to="/sales_page">{t('pages.sales')}</Nav.Link>
              <Nav.Link as={Link} to="/invoices_page">{t('pages.invoices')}</Nav.Link>

              <NavDropdown title={t('pages.commercial_network')}>
                <NavDropdown.Item as={Link} to="/commercial_network/agents">{t('pages.agents')}</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title={t('pages.banks')}>
                <NavDropdown.Item as={Link} to="/bank_entries">{t('pages.bank_entries')}</NavDropdown.Item>
              </NavDropdown>

              {
                props.loginParameters.roles.includes('root')
                &&
                <NavDropdown title="Teleconnect">
                  <NavDropdown.Item as={Link} to="/teleconnect/ventas">Ventas</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/teleconnect/agentes">Agentes</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/teleconnect/creditos">Créditos</NavDropdown.Item>
                </NavDropdown>
              }

              {
                props.loginParameters.roles.includes('root')
                &&
                <NavDropdown title="Root">
                  <NavDropdown.Item as={Link} to="/root_page">Root</NavDropdown.Item>
                </NavDropdown>
              }

            </Nav>

            <Nav className="justify-content-end" style={{ marginRight: "40px" }} >

              <NavDropdown title={props.loginParameters.userName}>
                <NavDropdown.Item as={Link} to="/settings">{t('settings')}</NavDropdown.Item>
                <NavDropdown.Item as={Button} onClick={props.logout}> <AiOutlineLogout style={{ marginRight: 5 }} />  {t('signOut')} </NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title={i18n.language}>
                <NavDropdown.Item
                  onClick={() => props.changeLanguage("es")}>
                  Español
                </NavDropdown.Item>
                <NavDropdown.Item
                  onClick={() => props.changeLanguage("en")}>
                  English
                </NavDropdown.Item>
              </NavDropdown>

            </Nav>

          </Navbar.Collapse>

        </Navbar>
        <div>
          <Routes>
            <Route path='/' element={<Home t={t} />} />
            <Route path='/about' element={<About />} />
            <Route path='/settings' element={<Settings />} />
            <Route path='/sales_page' element={<Sales loginParameters={props.loginParameters} t={t} i18n={i18n} />} />
            <Route path='/invoices_page' element={<InvoicesPage t={t} />} />
            <Route path='/root_page' element={<RootPage />} />
            
            {/* Teleconnect */}
            <Route path='/teleconnect/ventas' element={<TeleconnectSales loginParameters={props.loginParameters} t={t} i18n={i18n} />} />
            <Route path='/teleconnect/agentes' element={<TeleconnectAgents loginParameters={props.loginParameters} t={t} />} />
            <Route path='/teleconnect/creditos' element={<TeleconnectCredits loginParameters={props.loginParameters} t={t} />} />
            <Route path='/teleconnect_sales_page' element={<TeleconnectSales loginParameters={props.loginParameters} t={t} i18n={i18n} />} />
            
            {/* Red Comercial */}
            <Route path='/commercial_network/agents' element={<ShowAgents loginParameters={props.loginParameters} />} />
            <Route path='/commercial_network/agents/edit/:id' element={<EditAgent loginParameters={props.loginParameters} />} />
            <Route path='/commercial_network/agents/show/:id' element={<ShowAgent loginParameters={props.loginParameters} />} />
            
            {/* Bancos */}
            <Route path='/bank_entries' element={<ShowBankEntries loginParameters={props.loginParameters} />} />
            <Route path='/bank_entries/create' element={<CreateBankEntry loginParameters={props.loginParameters} />} />
            <Route path='/bank_entries/edit/:id' element={<EditBankEntry loginParameters={props.loginParameters} />} />
          </Routes>
        </div>
      </div>
    </BrowserRouter>
  );
};

export default RenderBrowserRouter;
